<div class="container py-3 PGConfirmBooking">
    @if (isLoading || isSaving) {
        <app-pg-loading [isLarge]="true" [isOverlay]="isSaving"></app-pg-loading>
    }
    @if (!isLoading) {
        <div>
            <div class="PGConfirmBooking-Header text-center">
                <h3>{{ 'pg-confirm-booking.manage-bookings' | locTranslate }}</h3>
                <h4 class="my-3">{{productDate | locFormat:'date'}}@if (productTime != null) {
                    - {{productTime | locFormat:'time'}}
                }</h4>
            </div>
            @if (productData != null) {
                <app-pg-product-card [productData]="productData" [supplierData]="supplierData"></app-pg-product-card>
            }
            <div class="row">
                <div class="col-12">
                    <h5 class="mt-4 px-2">{{ 'pg-confirm-booking.date-time' | locTranslate }}</h5>
                    <div class="PGBookedProduct-Selected border-top border-bottom p-2">
                        <div>
                            <div class="PGConfirmBooking-Field">
                                <span class="me-1">{{ 'pg-confirm-booking.date-time-day' | locTranslate }}</span><b>{{formatSelectedAvailabilityDate()}}</b>
                            </div>
                            @if (productTime != null) {
                                <div class="PGConfirmBooking-Field">
                                    <span class="me-1">{{ 'pg-confirm-booking.date-time-hour' | locTranslate }}</span><b>{{formatSelectedAvailabilityTime()}}</b>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="PGConfirmBooking-ReceivedHeader mt-4 mb-2 px-2">
                        <h5 class="m-0">{{ 'pg-confirm-booking.received-' + (cumulative ? 'cumulative' : 'bookings') | locTranslate }}</h5>
                        @if (bookingsData.length > 0) {
                            <div>
                                @if(!cumulative) {
                                    <button class="btn btn-sm btn-primary py-0 px-1 d-block" (click)="exportCSV()">
                                        <i class="fa-regular fa-download"></i><span>{{ 'pg-confirm-booking.booking-download' | locTranslate }}</span>
                                    </button>
                                }
                            </div>
                        }
                    </div>
                    @if (bookingsData.length == 0) {
                        <div class="border-top border-bottom py-2">
                            <span class="text-muted">{{ 'pg-confirm-booking.received-' + (cumulative ? 'cumulative' : 'bookings') + '-none' | locTranslate }}</span>
                        </div>
                    }
                    @for (booking of bookingsData; track booking; let i = $index) {
                        <div class="PGBookedProduct-Selected border-bottom {{i == 0 ? 'border-top' : ''}} pt-2 px-2">
                            <div>
                                <div class="PGConfirmBooking-Field">
                                    <span class="me-1">{{ 'pg-confirm-booking.booking-contact' | locTranslate }}</span>
                                    <div class="text-end">
                                        @if (booking.user_name != null) {
                                            <div>{{booking.user_name}}</div>
                                        }
                                        <div>@if (booking.user_email != null) {
                                            <a href="mailto:{{booking.user_email}}">{{booking.user_email}}</a>
                                        }</div>
                                        <div>@if (booking.user_phone != null) {
                                            <a href="tel:{{booking.user_phone}}">{{booking.user_phone}}</a>
                                        }</div>
                                    </div>
                                </div>
                                @if (booking.availability.from != null && booking.availability.to) {
                                    <div class="PGConfirmBooking-Field PGConfirmBooking-Field--Accommodation mt-1">
                                        <span class="me-1">{{ 'pg-confirm-booking.booking-period' | locTranslate }}</span>
                                        <span [innerHTML]="formatBookingPeriod(booking.availability)"></span>
                                    </div>
                                }
                                @if (productType == 'host') {
                                    @if (booking.booking_data != null) {
                                        <div class="PGConfirmBooking-Field PGConfirmBooking-Field--Accommodation mt-1">
                                            <span class="me-1">{{ 'pg-confirm-booking.booking-accommodation' | locTranslate }}</span>
                                            <span>{{formatAccommodationName(booking.booking_data)}}</span>
                                        </div>
                                    }
                                    @if (booking.tickets != null) {
                                        <div class="mt-1">
                                            @if (booking.tickets.fullQuantity > 0) {
                                                <div class="PGConfirmBooking-Field">
                                                    <span></span>
                                                    <span class="me-1">{{ 'pg-confirm-booking.label-full-price-single' | locTranslate }}</span>
                                                </div>
                                            }
                                            @for (other of booking.tickets.otherTickets; track other) {
                                                @if (other.quantity > 0) {
                                                    <div class="PGConfirmBooking-Field">
                                                        <span></span>
                                                        <span class="me-1">{{formatTicketName(other.name)}}</span>
                                                    </div>
                                                }
                                            }
                                        </div>
                                    }
                                }
                                @if (productType == 'experience' || productType == null) {
                                    @if (booking.tickets != null) {
                                        <div class="mt-1">
                                            @if (booking.tickets.fullQuantity > 0) {
                                                <div class="PGConfirmBooking-Field">
                                                    <span class="me-1">{{ 'pg-confirm-booking.label-full-price' | locTranslate }}</span><b>x {{booking.tickets.fullQuantity}}</b>
                                                </div>
                                            }
                                            @for (other of booking.tickets.otherTickets; track other) {
                                                @if (other.quantity > 0) {
                                                    <div class="PGConfirmBooking-Field">
                                                        <span class="me-1">{{formatTicketName(other.name)}}</span><b>x {{other.quantity}}</b>
                                                    </div>
                                                }
                                            }
                                        </div>
                                    }
                                }
                                @if (booking.survey_answers != null) {
                                    <div class="mt-1">
                                        @for (question of booking.survey_answers.questions; track question) {
                                            <div class="PGConfirmBooking-Field">
                                                <span class="me-1">{{formatQuestionText(question.text)}}</span>
                                                @if (question.type == 'boolean' && question.answer != null) {
                                                    <span>{{ 'pg-survey-editor.answer-boolean-' + question.answer  | locTranslate }}</span>
                                                }
                                                @if (question.type == 'string') {
                                                    <span>{{question.answer}}</span>
                                                }
                                            </div>
                                        }
                                    </div>
                                }
                                @if (booking.pid != null) {
                                    <div class="PGConfirmBooking-Field text-muted mt-1">
                                        <span class="me-1">PID</span>
                                        <span class="font-monospace text-uppercase">{{booking.pid}}</span>
                                    </div>
                                }
                            </div>
                            <div>
                                <div class="text-center py-2 mt-2 d-flex justify-content-between align-items-center">
                                    @if (booking.status == 'pending') {
                                        <div class="text-muted">
                                            <i class="fa-regular fa-ellipsis me-2"></i>
                                            <b>{{ 'pg-confirm-booking.status-pending' | locTranslate }}</b>
                                        </div>
                                    }
                                    @if (booking.status == 'canceled') {
                                        <div class="text-danger">
                                            <i class="fa-regular fa-times me-2"></i>
                                            <b>{{ 'pg-confirm-booking.status-canceled' | locTranslate }}</b>
                                        </div>
                                    }
                                    @if (booking.status == 'available') {
                                        <div class="text-primary">
                                            <i class="fa-regular fa-check me-2"></i>
                                            <b>{{ 'pg-confirm-booking.status-available' | locTranslate }}</b>
                                        </div>
                                    }
                                    @if (booking.status == 'confirmed') {
                                        <div class="text-success">
                                            <i class="fa-regular fa-check me-2"></i>
                                            <b>{{ 'pg-confirm-booking.status-confirmed' | locTranslate }}</b>
                                        </div>
                                    }
                                    @if (booking.status == 'handled') {
                                        <div class="text-primary">
                                            <i class="fa-regular fa-check me-2"></i>
                                            <b>{{ 'pg-confirm-booking.status-handled' | locTranslate }}</b>
                                        </div>
                                    }
                                    <div>
                                        @if (!isReadonly()) {
                                            @if (booking.status != 'canceled') {
                                                @if(!cumulative) {
                                                    <app-pg-confirm-action [disabled]="isSaving" (confirmed)="cancelBooking(booking)">
                                                        <button class="btn btn-sm btn-danger ms-1" [disabled]="isSaving">
                                                            <i class="fa-regular fa-times"></i>
                                                            <span>{{ 'pg-confirm-booking.button-cancel' | locTranslate }}</span>
                                                        </button>
                                                    </app-pg-confirm-action>
                                                }
                                            }
                                            @if (booking.status == 'pending') {
                                                <button [disabled]="isSaving" class="btn btn-sm btn-primary ms-1" (click)="confirmBooking(booking)">
                                                    <i class="fa-regular fa-check"></i>
                                                    <span>{{ 'pg-confirm-booking.button-' + (cumulative ? 'handle' : 'confirm') | locTranslate }}</span>
                                                </button>
                                            }
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                @if(!cumulative) {
                    <div class="col-12 PGConfirmBooking-SlotSummary">
                        <div class="border-bottom">
                            <h5 class="mt-4 px-2">{{ 'pg-confirm-booking.summary' | locTranslate }}</h5>
                            <div class="py-2 px-2 border-top">
                                @if (isSaving) {
                                    <app-pg-loading></app-pg-loading>
                                }
                                @if (!isSaving) {
                                    <app-pg-bookings-slot-summary [productData]="productData" [bookingsData]="bookingsData"></app-pg-bookings-slot-summary>
                                }
                            </div>
                        </div>
                    </div>
                }
                @if (!isReadonly() && (hasPendingBookings || hasNonCanceledBookings)) {
                    <div class="col-12 d-flex justify-content-center pt-3">
                        @if (hasNonCanceledBookings) {
                            @if(!cumulative) {
                                <div class="ms-1">
                                    <app-pg-confirm-action [disabled]="isSaving" (confirmed)="cancelSlot()">
                                        <button class="btn btn-danger btn-block" [disabled]="isSaving">
                                            <i class="fa-regular fa-times"></i>
                                            <span>{{ 'pg-confirm-booking.button-cancel-slot' | locTranslate }}</span>
                                        </button>
                                    </app-pg-confirm-action>
                                </div>
                            }
                        }
                        @if (hasPendingBookings) {
                            <div class="ms-1">
                                <button class="btn btn-primary btn-block" [disabled]="isSaving" (click)="confirmSlot()">
                                    <i class="fa-regular fa-check"></i>
                                    <span>{{ 'pg-confirm-booking.button-' + (cumulative ? 'handle' : 'confirm') + '-slot' | locTranslate }}</span>
                                </button>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    }
</div>